/**
 * ComplianceStats: two equal-width stat tiles summarising the employee's
 * outstanding compliance work, each opening the Transactions Task tab filtered to it.
 *
 * Amber for missing receipts, green for missing cost allocations (the green is
 * used even when the count is 0 because the tone signals the category, not
 * severity).
 */
import {
  CheckListIcon,
  Invoice01Icon,
} from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { Avatar, StatCard } from "@outpave/ds";
import { Columns } from "components/layout/reusableLayouts";
import { useTranslation } from "react-i18next";

export interface ComplianceStatsProps {
  missingReceipts: number;
  missingAllocations: number;
  loadingReceipts?: boolean;
  loadingAllocations?: boolean;
  onSelectReceipts?: () => void;
  onSelectAllocations?: () => void;
}

const ComplianceStats = ({
  missingReceipts,
  missingAllocations,
  loadingReceipts = false,
  loadingAllocations = false,
  onSelectReceipts,
  onSelectAllocations,
}: ComplianceStatsProps) => {
  const { t } = useTranslation();

  return (
    <Columns count={{ xs: 1, sm: 2 }} gap="var(--space-7)">
      <StatCard
        orientation="horizontal"
        title={t("Missing Receipts")}
        value={missingReceipts}
        loading={loadingReceipts}
        leading={
          <Avatar
            size="lg"
            color="warning"
            icon={<HugeiconsIcon icon={Invoice01Icon} size={16} />}
          />
        }
        action={
          onSelectReceipts
            ? { type: "open", onClick: onSelectReceipts }
            : undefined
        }
      />
      <StatCard
        orientation="horizontal"
        title={t("Missing Allocations")}
        value={missingAllocations}
        loading={loadingAllocations}
        leading={
          <Avatar
            size="lg"
            color="success"
            icon={<HugeiconsIcon icon={CheckListIcon} size={16} />}
          />
        }
        action={
          onSelectAllocations
            ? { type: "open", onClick: onSelectAllocations }
            : undefined
        }
      />
    </Columns>
  );
};

export default ComplianceStats;
